import styled from '@emotion/styled'

import { APP_TYPE } from '@/types/User'

type Props = {
  activeApp: APP_TYPE
  onClick: () => void
  open: boolean
}

export default function Burger({ open, onClick, activeApp }: Props) {
  const helperText = !open ? 'Open Navigation Menu' : 'Close Navigation Menu'
  return (
    <StyledBurger
      activeApp={activeApp}
      aria-expanded={open ? 'true' : 'false'}
      aria-label="Mobile Navigation Button"
      className="burger"
      data-testid="nav-burger"
      onClick={onClick}
      type="button"
    >
      <div className={`${open ? 'open' : ''} bar1 bars`} />
      <div className={`${open ? 'open' : ''} bar2 bars`} />
      <div className={`${open ? 'open' : ''} bar3 bars`} />
      <span className="sr-only">{helperText}</span>
    </StyledBurger>
  )
}

export const StyledBurger = styled.button<{ activeApp: APP_TYPE }>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
  margin-right: 2rem;
  width: 20px;
  height: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;

  &:focus {
    outline: none;
  }

  .bars {
    position: relative;
    border-radius: 0.5rem;
    width: 24px;
    height: 2px;
    transition: all 0.3s linear;
    transform-origin: 1px;
    ${({ activeApp }) => (activeApp === APP_TYPE.SALES ? 'background-color: #000000;' : 'background-color: white;')}
  }

  .bar1 {
    transform: 'rotate(0)';
  }

  .bar1.open {
    transform: rotate(45deg);
  }

  .bar3 {
    transform: rotate(0);
  }

  .bar3.open {
    transform: rotate(-45deg);
  }

  .bar2 {
    opacity: 1;
    transform: translateX(0);
  }

  .bar2.open {
    opacity: 0;
    transform: translateX(20px);
  }
`
